<template>
	<div>
		<div class="img-top">
			<div class="bg flex-col items-center">
				<div class="text-title">
					{{detail.title}}
				</div>
				<div class="title-time">
					<span style="margin-right: 0.17rem;">开始时间</span>
					<span style="margin-right: 0.52rem;">{{detail.startTime}}</span>
					<span style="margin-right: 0.17rem;">结束时间</span>
					<span>{{detail.endTime}}</span>
				</div>
			</div>
		</div>
		<div class="content">
			<div class="center" v-html="detail.conment">
			
			</div>
		</div>
	</div>
</template>

<script>
	import {newsDetailApi} from '../../http/api/ordinary.js'
	export default{
		data(){
			return{
				detail:{}
			}
		},
		created() {
			this.init(this.$route.query.id)
		},
		methods:{
			init(id){
				newsDetailApi({
					id
				}).then(res => {
					this.detail = res
				})
			}
		}
	}
</script>

<style scoped>
	.img-top{
		height: 150px;
		background: url('../../assets/image/tingdian.png') no-repeat;
		background-size: cover;
	}
	.text-title{
		font-size: .30rem;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: .42rem;
		margin-bottom: .25rem;
		margin-top: 20px;
		letter-spacing: .03rem;
	}
	.title-time{
		font-size: .16rem;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
	}
	.content{
		background: #F5F5F5;
		padding: 10px 0;
	}
	.center{
		 -webkit-box-sizing: border-box;
		width: 15.20rem;
		margin: 0 auto;
		padding: 10px;
		min-height: 450px;
		background-color: #FFFFFF;
		font-size: .16rem;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #464646;
		line-height: .31rem;
		
	}
	.center p{
		margin: 0;
	}
</style>